module.exports = __webpack_public_path__ + "media/images/covid/logo-e45a931f0b0977ec74a6a21846bb4403.png";